export enum BadgeFieldType {
  Host = 'Host',
  MeetingTitle = 'Meeting.Title',
  MeetingTitleDate = 'Meeting.TitleDate',
  MeetingLocation = 'Meeting.Location',
  MeetingLocationDate = 'Meeting.LocationDate',
  ArrivedDate = 'ArrivedDate',
  CheckinAt = 'CheckinAt',
  Message = 'Message',
  cardNumber = 'cardNumber',
  name = 'name',
  email = 'email',
  phone = 'phone',
  cpf = 'cpf',
  rg = 'rg',
  hostCompany = 'HostCompany',
  document = 'document',
  companyname = 'companyname',
  address = 'address',
  position = 'position',
  plate = 'plate',
  sector = 'sector',
  chosen_name = 'chosen_name',
}
